import { Message } from 'element-ui'
import store from '@/store'

let Socket = ''
let setIntervalWesocketPush = null
var lockReconnect = false // 避免重复连接
let imUrl = ''

// 建立websocket连接
export const createSocket = () => {
    imUrl = process.env.VUE_APP_IM_API + '?sign=' + store.state.ws.sign + '&ts=' + store.state.ws.ts
    Socket && Socket.close()
    if (!Socket) {
        console.log('建立websocket连接')
        Socket = new WebSocket(imUrl)
        Socket.onmessage = onmessageWS
        Socket.onerror = onerrorWS
        Socket.onclose = oncloseWS
    } else {
        console.log('websocket已连接')
    }
}

// 断开websocket连接
export const closeSocket = () => {
  Socket && Socket.close()
  clearInterval(setIntervalWesocketPush)
}

// 发送心跳
export const sendPing = (durationVal) => {
    if (setIntervalWesocketPush) clearInterval(setIntervalWesocketPush)
    Socket.send('{"event":"ping","content":"ping heartbeat"}')
    setIntervalWesocketPush = setInterval(() => {
        Socket.send('{"event":"ping","content":"ping heartbeat"}')
    }, durationVal)
}

// 发送数据
export const sendWSPush = message => {
    if (Socket !== null && Socket.readyState === 3) {
        Socket.close()
        createSocket()
    } else if (Socket.readyState === 1) {
        Socket.send(JSON.stringify(message))
    } else if (Socket.readyState === 0) {
        connecting(message)
    }
}

// 发送数据但连接未建立时进行处理等待重发
const connecting = message => {
    setTimeout(() => {
        if (Socket.readyState === 0) {
            connecting(message)
        } else {
            Socket.send(JSON.stringify(message))
        }
    }, 1000)
}

// 数据接收统一处理
const onmessageWS = e => {
    window.dispatchEvent(new CustomEvent('onmessageWS', {
        detail: {
            data: e.data
        }
    }))
}

// 连接失败重连
const onerrorWS = (e) => {
    Socket.close()
    clearInterval(setIntervalWesocketPush)
    window.dispatchEvent(new CustomEvent('onerrorWS'))
    if (Socket.readyState !== 3) {
        Socket = null
        if (e.code == 1000) return
        if (lockReconnect) return
        lockReconnect = true
        setTimeout(function() {
            createSocket()
            lockReconnect = false
        }, 5000)
    }
}

// 断开重连
const oncloseWS = (e) => {
    clearInterval(setIntervalWesocketPush)
    window.dispatchEvent(new CustomEvent('oncloseWS'))
    if (Socket.readyState !== 2) {
        Socket = null
        console.log(e)
        if (e.code == 1000) return
        if (lockReconnect) return
        lockReconnect = true
        setTimeout(function() {
            createSocket()
            lockReconnect = false
        }, 5000)
    }
}
